export default __webpack_public_path__ + "static/media/carteiras.2911fbe8.png";